import { format } from "date-fns";
import { useFormik } from "formik";
import React from "react";
import { Spinner } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import * as yup from "yup";
import { fetchOrders } from "../../Services/OrderService";

const orderStatuses = {
  pending: "Pending",
  confirmed: "Assigned Order",
  processing: "In process",
  picked_up: "Picked Up",
  delivered: "Delivered",
  out_for_delivery: "Out For Delivery",
  failed: "Payment Failed",
  ready_for_delivery: "Ready For Delivery",
  returned: "Returned",
  arrived: "Received at Hub",
  out_for_pickup: "Out for pickup",
  cancelled: "Cancelled",
  deferred: "Re-attempt",
  disputed: "Disputed",
};
const validationSchema = yup.object().shape({
  orderId: yup.string(),
});

export const Orders = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [details, setDetails] = React.useState(null);
  const [loading, setLoading] = React.useState(false);

  const formik = useFormik({
    initialValues: {
      orderId: "",
    },
    validationSchema,
    onSubmit: (v) => {
      const payload = { ...v };
      for (const key in payload) {
        if (Object.prototype.hasOwnProperty.call(payload, key)) {
          const x = payload[key];
          if (!x) delete payload[key];
        }
      }
      const p = serialize(payload);
      if (p && p !== "?") {
        getOrders(undefined, p);
      }
    },
  });

  const serialize = (obj) => {
    var str = [];
    for (var p in obj)
      if (obj.hasOwnProperty(p) && obj[p].trim()) {
        str.push(
          encodeURIComponent(p) + "=" + encodeURIComponent(obj[p].trim())
        );
      }
    return `${str.join("&")}`;
  };

  const getOrders = (url, params) => {
    setLoading(true);
    fetchOrders(url, params)
      .then((res) => {
        for (let i = 0; i < res?.data?.length; i++) {
          const row = res?.data?.[i];
          row.qq = 0;
          for (let j = 0; j < row?.details?.length; j++) {
            const item = row?.details?.[j];
            row.qq += item.quantity;
          }
        }
        return res;
      })
      .then(
        (res) => {
          setDetails(res);
          setLoading(false);
        },
        (err) => {
          console.warn(err);
          toast.error("Something went wrong while fetching customer details.");
        }
      );
  };

  React.useEffect(() => {
    getOrders();
    dispatch({ type: "setCart", payload: [] });
    dispatch({ type: "setPickupDate", payload: null });
    dispatch({ type: "setDeliveryDate", payload: null });
    dispatch({ type: "setAddresses", payload: null });
    dispatch({ type: "setOrderType", payload: null });
    dispatch({ type: "setOrderTypeId", payload: null });
    dispatch({ type: "setBookingType", payload: null });
    dispatch({ type: "setCoupon", payload: null });
    dispatch({ type: "setService", payload: null });
    dispatch({ type: "setCategory", payload: null });
  }, []);

  return (
    <div className="container py-4" style={{ minHeight: "80vh" }}>
      <div className="row">
        <div className="col-12">
          <div className="card">
            {/* <div className="card-header bg-white">
              
            </div> */}
            <div className="card-body">
              <h3 className="mb-0 ">
                Orders{" "}
                {details ? (
                  <span className="roles-count">{details?.total}</span>
                ) : null}
              </h3>
              <hr style={{ borderColor: "#282828" }} />
              {Boolean(details) && !loading ? (
                <>
                  <form
                    className="row align-items-end"
                    onSubmit={formik.handleSubmit}
                  >
                    <div className="col-lg-3 col-md-4 col-12">
                      <Form.Group controlId="orderId">
                        <Form.Control
                          type="text"
                          name="orderId"
                          style={{ padding: "0.375rem 0.75rem" }}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.orderId}
                          placeholder="Order ID"
                        />
                      </Form.Group>
                    </div>
                    <div className="col-lg-3 col-md-4 col-12">
                      <button
                        className="btn btn-dark d-block"
                        style={{ height: "44px" }}
                        type="submit"
                        disabled={!formik.isValid}
                      >
                        Search
                      </button>
                    </div>
                  </form>
                  <hr
                    style={{
                      borderColor: "#282828",
                      marginBottom: !loading ? "0px" : "",
                    }}
                  />
                </>
              ) : null}
              {Boolean(details) && !loading ? (
                <>
                  <div className="table-responsive">
                    <table className="table">
                      <thead className="table-light">
                        <tr>
                          <th scope="col" style={{ minWidth: "90px" }}>
                            S.NO
                          </th>
                          <th scope="col" style={{ minWidth: "150px" }}>
                            Order
                          </th>
                          <th scope="col" style={{ minWidth: "180px" }}>
                            Date
                          </th>
                          <th scope="col" style={{ minWidth: "180px" }}>
                            Rider Name
                          </th>
                          <th scope="col" style={{ minWidth: "180px" }}>
                            Customer
                          </th>
                          <th scope="col" style={{ minWidth: "130px" }}>
                            Platform
                          </th>
                          <th scope="col" style={{ minWidth: "150px" }}>
                            Pickup Date
                          </th>
                          <th scope="col" style={{ minWidth: "200px" }}>
                            Pickup Time Slot
                          </th>
                          <th scope="col" style={{ minWidth: "150px" }}>
                            Delivery Date
                          </th>
                          <th scope="col" style={{ minWidth: "200px" }}>
                            Delivery Time Slot
                          </th>
                          <th scope="col" style={{ minWidth: "150px" }}>
                            Payment Status
                          </th>
                          <th scope="col" style={{ minWidth: "220px" }}>
                            Cancel User
                          </th>
                          <th scope="col" style={{ minWidth: "130px" }}>
                            Total
                          </th>
                          <th scope="col" style={{ minWidth: "180px" }}>
                            Order Status
                          </th>
                          <th scope="col" style={{ minWidth: "150px" }}>
                            Deferred At
                          </th>
                          <th scope="col" style={{ minWidth: "230px" }}>
                            Order Type
                          </th>
                          <th scope="col" style={{ minWidth: "130px" }}>
                            No of Bags
                          </th>
                          <th scope="col" style={{ minWidth: "130px" }}>
                            Quantity
                          </th>
                          <th scope="col">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {details?.data?.map((order, i) => (
                          <tr>
                            <td>{i + 1}</td>
                            <td>
                              <span
                                className="text-primary cursor-pointer"
                                onClick={() => {
                                  navigate(`./view/${order.id}`);
                                }}
                              >
                                {order.id}
                              </span>
                            </td>
                            <td>{format(order.created_at, "do MMM yyyy")}</td>
                            <td>---</td>
                            <td>
                              {order.customer
                                ? `${order.customer?.f_name} ${order.customer?.l_name}`
                                : "---"}
                            </td>
                            <td>
                              {order.platform === 0
                                ? "App"
                                : order.platform === 1
                                ? "Web"
                                : order.platform === 2
                                ? "CRM"
                                : order.platform === 3
                                ? "WhatsApp"
                                : order.platform === 4
                                ? "In-Store"
                                : order.platform}
                            </td>
                            <td>{order.pickup_date}</td>
                            <td>{order.order_pickup_time_slot}</td>
                            <td>{order.delivery_date}</td>
                            <td>{order.order_delivery_time_slot}</td>
                            <td>
                              {order.payment_status === "paid" ? (
                                <span className="badge text-bg-success">
                                  Paid
                                </span>
                              ) : (
                                <span className="badge text-bg-danger">
                                  Unpaid
                                </span>
                              )}
                            </td>
                            <td>
                              {order.cancel_user
                                ? `${order.cancel_user.f_name} ${order.cancel_user.l_name} (Customer)`
                                : order.cancel_rider
                                ? `${order.cancel_rider.f_name} ${order.cancel_rider.l_name} (Rider)`
                                : "---"}
                            </td>
                            <td>Rs {order.order_amount?.toLocaleString()}</td>
                            <td>{orderStatuses[order.order_status]}</td>
                            <td>{order.deferred_at ?? "---"}</td>
                            <td>
                              {order.delivery_type?.title}{" "}
                              {order.delivery_type?.id != 1 &&
                              order.delivery_type?.id != 2
                                ? order.booking_type == 1
                                  ? "(Regular)"
                                  : "Express"
                                : null}
                            </td>
                            <td>{order.bags?.length?.toLocaleString()}</td>
                            <td>{order.qq?.toLocaleString()}</td>
                            <td className="action-td">
                              <span
                                onClick={() => {
                                  navigate(`./view/${order.id}`);
                                }}
                              >
                                <i className="fa-regular fa-eye"></i>
                              </span>
                              <span
                                onClick={() => {
                                  if (
                                    ["delivered", "cancelled"].includes(
                                      order.order_status
                                    ) ||
                                    order.payment_status === "paid"
                                  )
                                    toast.error("This order cannot be edited.");
                                  else navigate(`./edit/${order.id}`);
                                }}
                              >
                                <i className="fa-solid fa-pen-to-square"></i>
                              </span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="w-100 d-flex align-items-center justify-content-between flex-wrap pt-3">
                    <nav aria-label="Page navigation example">
                      {details?.links?.length > 3 ? (
                        <ul className="pagination justify-content-end mb-0">
                          {details?.links?.map((link, index) => (
                            <li
                              className={`page-item ${
                                link.active ? "active" : ""
                              }`}
                              key={index}
                            >
                              <span
                                onClick={() => {
                                  if (!loading) {
                                    getOrders(link.url);
                                  }
                                }}
                                className="page-link cursor-pointer"
                                dangerouslySetInnerHTML={{
                                  __html: link.label,
                                }}
                              />
                            </li>
                          ))}
                        </ul>
                      ) : null}
                    </nav>

                    <span>
                      Showing {details?.from} to {details?.to} of{" "}
                      {details?.total}
                    </span>
                  </div>
                </>
              ) : (
                <div className="text-center w-100">
                  <Spinner variant="primary" />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
